import * as React from 'react';
import { AnalyticsContext, trackEvent } from 'latitude-analytics';
import styled from 'styled-components';
import classnames from 'classnames';
import { parseContent } from '../../../utils/helpers';
import { BREAKPOINT, CALCULATOR_TRACKING } from '../../../utils/constants';
import './_radio-boxes.scss';
import Typography from '@latitude/typography';

const component = 'radio-box';

const StyledLabel = styled.label`
  flex-basis: ${({ equalWidths, noOfItems }) =>
    equalWidths ? `${100 / Number(noOfItems)}%` : 'auto'};
  width: ${({ equalWidths, noOfItems }) =>
    equalWidths ? `${100 / Number(noOfItems)}%` : 'auto'};
  padding: ${({ equalWidths }) => (equalWidths ? `0.75rem 0px` : '0.75rem')};

  @media (max-width: ${BREAKPOINT.SM}) {
    padding: ${({ equalWidths }) => (equalWidths ? `1rem 0px` : '1rem')};
  }
`;

const RadioBoxes = props => {
  const {
    labelText,
    values,
    selectedValue,
    name,
    onChange,
    showError,
    showErrorMessage,
    className,
    inverted,
    equalWidths,
    pluralLabel,
    calculatorTracking=CALCULATOR_TRACKING,
  } = props;

  const labelErrorClass = showError ? `${component}__label-error` : '';

  return (
    <AnalyticsContext.Consumer>
      {([analytics]) => (
        <div className="input-wrap">
          {labelText && (
            /* eslint-disable-next-line */
            <label
              className={classnames(
                labelErrorClass,
                inverted ? `${component}__label-inverted` : ''
              )}
            >
              {parseContent(labelText)}
            </label>
          )}
          <div
            className={classnames(
              'lfs-radio',
              'radio-boxes',
              inverted
                ? 'radio-boxes__inverted-color'
                : 'radio-boxes__default-color',
              className
            )}
          >
            {values.map((item, index) => {
              let labelClass = `lfs-radio-label ${component}__label`;
              const generatedId = `${component}-${name}-${index}`;
              const checked =
                selectedValue !== undefined &&
                selectedValue.toString() === item.value.toString();

              if (checked) {
                labelClass += ' active';
              }
              return (
                <StyledLabel
                  id={`${generatedId}-label`}
                  htmlFor={generatedId}
                  key={index}
                  className={labelClass}
                  equalWidths={equalWidths}
                  noOfItems={values.length}
                >
                  <input
                    id={generatedId}
                    type="radio"
                    className={`${component}__input`}
                    value={item.value}
                    checked={checked}
                    onChange={onChange}
                    onClick={event => {
                      const pluralSuffix =
                        event.currentTarget.labels[0].textContent === '1'
                          ? ''
                          : 's';

                      if (trackEvent) {
                        trackEvent(analytics, {
                          category: calculatorTracking.CATEGORY,
                          action: calculatorTracking.ACTION,
                          label: pluralLabel
                            ? `${event.currentTarget.labels[0].textContent} ${pluralLabel}${pluralSuffix}`
                            : event.currentTarget.labels[0].textContent,
                          location: calculatorTracking.LOCATION
                        });
                      }
                    }}
                    name={name}
                  />
                  <span className={`${component}__text`}>
                    <Typography.CTARegular>{parseContent(item.text)}</Typography.CTARegular>
                  </span>
                </StyledLabel>
              );
            })}
          </div>
          {showError && (
            <div className={`${component}__error-container`}>
              <div className={`${component}__error-message`}>
                {showErrorMessage}
              </div>
            </div>
          )}
        </div>
      )}
    </AnalyticsContext.Consumer>
  );
};

export default RadioBoxes;
